import React from 'react'
import { Route, Switch } from 'react-router-dom'
import _ from 'lodash'

import core from '../../core'

import List from './List'
import Detail from './Detail'
import SectionDetail from './SectionDetail'

const { components: { Auth, NoMatch } } = core

const InnerRouter = props => {
  const {
    innerRouterInput: {
      valueTable,
      commonConfigValues,
      subForms,
      propsToPass,
      propsToPass: { constantProps: { PATH } },
      getConfig,
      getDataFunctions
    }
  } = props

  return (
    <Switch>
      <Route
        exact
        path={`${PATH}:id(new|\\d{1,})`}
        render={routeProps => {
          const sectionPath = `${PATH}`
          const values = {
            ...valueTable,
            ...commonConfigValues
          }
          const sectionExists =
            _.findIndex(subForms, ['path', sectionPath]) > -1
          return (
            <Auth app>
              {sectionExists ? (
                <Detail
                  sectionPath={sectionPath}
                  config={getConfig(sectionPath, values)}
                  {...propsToPass}
                  {...props}
                  {...routeProps}
                />
              ) : (
                <div
                  style={{
                    marginTop: 70,
                    padding: 10
                  }}
                >
                  <NoMatch {...props} {...routeProps} />
                </div>
              )}
            </Auth>
          )
        }}
      />
      <Route
        exact
        path={`${PATH}:id(new|\\d{1,})/:form`}
        render={routeProps => {
          const sectionPath = `${PATH}`
          const values = {
            ...valueTable,
            ...commonConfigValues
          }
          const sectionExists =
            _.findIndex(subForms, ['path', sectionPath]) > -1
          return (
            <Auth app>
              {sectionExists ? (
                <Detail
                  sectionPath={sectionPath}
                  config={getConfig(sectionPath, values)}
                  {...propsToPass}
                  {...props}
                  {...routeProps}
                />
              ) : (
                <div
                  style={{
                    marginTop: 70,
                    padding: 10
                  }}
                >
                  <NoMatch {...props} {...routeProps} />
                </div>
              )}
            </Auth>
          )
        }}
      />
      <Route
        exact
        path={`${PATH}:section/:id(new|\\d{1,})`}
        render={routeProps => {
          const sectionPath = `${PATH}${routeProps.match.params.section}/`
          const values = {
            ...valueTable,
            ...commonConfigValues
          }
          const propsAdjusted = {
            ...propsToPass,
            getData: getDataFunctions(sectionPath)
          }
          const sectionExists =
            _.findIndex(subForms, ['path', sectionPath]) > -1
          return (
            <Auth app>
              {sectionExists ? (
                <SectionDetail
                  sectionPath={sectionPath}
                  config={getConfig(sectionPath, values)}
                  {...propsAdjusted}
                  {...props}
                  {...routeProps}
                />
              ) : (
                <div
                  style={{
                    marginTop: 70,
                    padding: 10
                  }}
                >
                  <NoMatch {...props} {...routeProps} />
                </div>
              )}
            </Auth>
          )
        }}
      />
      <Route
        exact
        path={`${PATH}:section/:id(new|\\d{1,})/:form`}
        render={routeProps => {
          const sectionPath = `${PATH}${routeProps.match.params.section}/`
          const values = {
            ...valueTable,
            ...commonConfigValues
          }
          const propsAdjusted = {
            ...propsToPass,
            getData: getDataFunctions(sectionPath)
          }
          const sectionExists =
            _.findIndex(subForms, ['path', sectionPath]) > -1

          return (
            <Auth app>
              {sectionExists ? (
                <SectionDetail
                  sectionPath={sectionPath}
                  config={getConfig(sectionPath, values)}
                  {...propsAdjusted}
                  {...props}
                  {...routeProps}
                />
              ) : (
                <div
                  style={{
                    marginTop: 70,
                    padding: 10
                  }}
                >
                  <NoMatch {...props} {...routeProps} />
                </div>
              )}
            </Auth>
          )
        }}
      />
      <Route
        exact
        path={`${PATH}:section`}
        render={routeProps => {
          const sectionPath = `${PATH}${routeProps.match.params.section}/`
          const values = {
            ...valueTable,
            ...commonConfigValues
          }
          const propsAdjusted = {
            ...propsToPass,
            getData: getDataFunctions(sectionPath)
          }
          const sectionExists =
            _.findIndex(subForms, ['path', sectionPath]) > -1
          return (
            <Auth app>
              {sectionExists ? (
                <List
                  sectionPath={sectionPath}
                  config={getConfig(sectionPath, values)}
                  {...propsAdjusted}
                  {...props}
                  {...routeProps}
                />
              ) : (
                <div
                  style={{
                    marginTop: 70,
                    padding: 10
                  }}
                >
                  <NoMatch {...props} {...routeProps} />
                </div>
              )}
            </Auth>
          )
        }}
      />
      <Route
        exact
        path={`${PATH}`}
        render={routeProps => {
          const sectionPath = `${PATH}`
          const values = {
            ...valueTable,
            ...commonConfigValues
          }
          const sectionExists =
            _.findIndex(subForms, ['path', sectionPath]) > -1
          return (
            <Auth app>
              {sectionExists ? (
                <List
                  sectionPath={sectionPath}
                  config={getConfig(sectionPath, values)}
                  {...propsToPass}
                  {...props}
                  {...routeProps}
                />
              ) : (
                <div
                  style={{
                    marginTop: 70,
                    padding: 10
                  }}
                >
                  <NoMatch {...props} {...routeProps} />
                </div>
              )}
            </Auth>
          )
        }}
      />
      <Route
        render={routeProps => (
          <Auth app>
            <div
              style={{
                marginTop: 70,
                padding: 10
              }}
            >
              <NoMatch {...props} {...routeProps} />
            </div>
          </Auth>
        )}
      />
    </Switch>
  )
}

export default InnerRouter



// WEBPACK FOOTER //
// ./src/common/components/InnerRouter.js